"use client";

import { useEffect } from "react";

import api from "@/api";
import { useAnalytics } from "@/hooks/useAnalytics";
import { FunnelEvent } from "@/types/analytics";
import { PostResponseType } from "@/types/post";

interface PostViewCounterProps {
  postId: PostResponseType["id"];
  postSlug?: string;
  postTitle?: string;
}

function PostViewCounter({ postId, postSlug, postTitle }: PostViewCounterProps) {
  const { trackFunnelEvent, trackPageView } = useAnalytics();

  useEffect(() => {
    // Track API view count
    api.post.addView(postId);

    // Track PostHog blog post view
    trackFunnelEvent(FunnelEvent.BLOG_POST_VIEWED, {
      post_id: postId,
      post_slug: postSlug || "unknown",
      post_title: postTitle || "unknown"
    });

    // Track general page view
    trackPageView(`blog_post_${postSlug}`, {
      page_type: "blog_post",
      post_id: postId
    });
  }, [postId, postSlug, postTitle, trackFunnelEvent, trackPageView]);

  return null;
}

export default PostViewCounter;
